import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=55876654"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=55876654&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WhiteDogMenu: require('/var/www/html/source/components/WhiteDog/Menu/Menu.vue').default,WhiteCatMenu: require('/var/www/html/source/components/WhiteCat/Menu/Menu.vue').default})
